module.exports = __webpack_public_path__ + "media/images/color_admin_v3/gallery/gallery-5-9890987ee833c99998f75206ad1362cf.jpg";